import { render, staticRenderFns } from "./global-state-aggregator-wom.vue?vue&type=template&id=c0942e26&scoped=true&"
import script from "./global-state-aggregator-wom.vue?vue&type=script&lang=js&"
export * from "./global-state-aggregator-wom.vue?vue&type=script&lang=js&"
import style0 from "./global-state-aggregator-wom.vue?vue&type=style&index=0&id=c0942e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0942e26",
  null
  
)

export default component.exports